import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaUserPlus } from 'react-icons/fa';
import { FormStoreUser } from '../../components/FormStoreUser';

const AddUserModal = ({ show, handleClose }) => {
  const handleUserAdded = () => {
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="master-user-modal-dialog master-user-modal-dialog--add"
      contentClassName="master-user-modal"
    >
      <Modal.Header closeButton className="master-user-modal__header">
        <div className="master-user-modal__titlebar">
          <span className="master-user-modal__icon">
            <FaUserPlus />
          </span>
          <div>
            <span className="master-user-modal__eyebrow">Panel master</span>
            <Modal.Title>Agregar usuario</Modal.Title>
          </div>
        </div>
      </Modal.Header>
      <Modal.Body className="master-user-modal__body">
        <FormStoreUser onUserAdded={handleUserAdded} onCancel={handleClose} />
      </Modal.Body>
    </Modal>
  );
};

export default AddUserModal;
